module.exports = __webpack_public_path__ + "static/memphis-pattern-33545ec6ffda90e786dea627ce363688.png";